/* Mobile menu burger toggle — every .gh-burger on the page (the
   original one in #gh-navigation, plus home/menu-bar.hbs's own
   centered copy on the home page) opens/closes the same single
   overlay in #gh-navigation. Each burger also gets its own is-open
   class, purely so its icon can swap independently of the others
   (see custom.css) — .home-menu-bar-burger sits outside
   #gh-navigation, so it can't rely on screen.css's .is-open
   .gh-burger svg:first-child (that needs the burger to be a
   descendant of the is-open element, which only #gh-navigation's
   own burger is). */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burgers = document.querySelectorAll('.gh-burger');
    if (!navigation || !burgers.length) return;

    function closeMenu() {
        navigation.classList.remove('is-open');
        document.documentElement.style.overflowY = null;
        burgers.forEach(function (b) {
            b.classList.remove('is-open');
        });
    }

    burgers.forEach(function (burger) {
        burger.addEventListener('click', function () {
            if (!navigation.classList.contains('is-open')) {
                navigation.classList.add('is-open');
                document.documentElement.style.overflowY = 'hidden';
                burgers.forEach(function (b) {
                    b.classList.add('is-open');
                });
            } else {
                closeMenu();
            }
        });
    });

    /* Leaving mobile width (e.g. widening the window) with the
       overlay open otherwise leaves it stuck open — it's built for
       mobile only (full-screen black, no desktop styling), so
       widening past that breakpoint needs to close it same as a
       burger click would. */
    const mobileMediaQuery = window.matchMedia('(max-width: 767px)');
    mobileMediaQuery.addEventListener('change', function (e) {
        if (!e.matches && navigation.classList.contains('is-open')) {
            closeMenu();
        }
    });
})();

/* Fade at the top/bottom edges of the open mobile menu's link list
   (home page only, see custom.css's has-fade-top/has-fade-bottom
   rules) when it overflows and needs its own internal scroll — a
   visual hint that there's more to scroll to, beyond the "menu ends
   abruptly at the edge of the screen" look it'd have otherwise. Only
   the edge that actually still has hidden content gets faded — e.g.
   scrolled all the way to the bottom drops has-fade-bottom, even
   though the list is still scrollable overall, since there's nothing
   hidden past that edge specifically anymore. Both scroll (updates as
   the user scrolls) and ResizeObserver (open/close, window resize,
   orientation change — whatever changes the menu's rendered size). */
(function () {
    const menu = document.querySelector('#gh-navigation .gh-navigation-menu');
    if (!menu) return;

    const updateFade = () => {
        const canScroll = menu.scrollHeight > menu.clientHeight + 1;
        menu.classList.toggle('has-fade-top', canScroll && menu.scrollTop > 4);
        menu.classList.toggle('has-fade-bottom', canScroll && menu.scrollTop + menu.clientHeight < menu.scrollHeight - 4);
    };

    menu.addEventListener('scroll', updateFade);

    if (window.ResizeObserver) {
        new ResizeObserver(updateFade).observe(menu);
    }

    updateFade();
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Post Capa template (custom-post-capa.hbs) — the top image is the
   post's first body image, moved out of the body (so it doesn't show
   twice) into the header's full-screen figure, replacing the feature
   image. The feature image stays as the fallback (and the no-JS
   version) for a post with no image in the body. */
(function () {
    var figure = document.querySelector('.js-capa-post-image');
    var card = document.querySelector('.gh-article--capa .gh-content .kg-image-card');
    var img = card && card.querySelector('img');

    if (!figure || !img) {
        return;
    }

    img.setAttribute('sizes', '100vw');
    img.removeAttribute('loading');

    var caption = card.querySelector('figcaption');

    figure.replaceChildren(img);
    if (caption) {
        figure.appendChild(caption);
    }

    figure.hidden = false;
    card.remove();
})();

/* Edição section — the print-instructions image opens in the same
   PhotoSwipe lightbox as post gallery images, but as a single item.
   Not routed through lightbox() above: that function's sibling
   traversal (for multi-image galleries) expects a Koenig .kg-card
   wrapper, which this plain <img> doesn't have. */
(function () {
    document.querySelectorAll('.home-edicao-print-instructions').forEach(function (img) {
        img.addEventListener('click', function () {
            var pswpElement = document.querySelectorAll('.pswp')[0];

            var items = [{
                src: img.getAttribute('src'),
                msrc: img.getAttribute('src'),
                w: img.naturalWidth || parseInt(img.getAttribute('width'), 10) || 1200,
                h: img.naturalHeight || parseInt(img.getAttribute('height'), 10) || 800,
                el: img,
            }];

            var options = {
                bgOpacity: 0.9,
                closeOnScroll: true,
                fullscreenEl: false,
                history: false,
                index: 0,
                shareEl: false,
                /* Reserves this much viewport space around the image when
                   PhotoSwipe sizes it — keeps the white box-shadow "frame"
                   added in screen.css (.pswp__img[src*=".svg"]) from being
                   clipped by the viewport edges, especially on small
                   screens where the image is already close to full width. */
                padding: {top: 40, bottom: 40, left: 40, right: 40},
                getThumbBoundsFn: function () {
                    var pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                    var rect = img.getBoundingClientRect();

                    return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
                }
            };

            var gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
            gallery.init();
        });
    });
})();

/* Edição section — the post title feeding .home-edicao-number-value can
   carry a parenthesized aside (editors reuse the post title elsewhere
   too), which doesn't belong in the number display. */
(function () {
    document.querySelectorAll('.home-edicao-number-value').forEach(function (el) {
        el.textContent = el.textContent.replace(/\([^)]*\)/g, '').trim().slice(0, 3);
    });
})();

/* Um Poema archive — reveals the "…" ellipsis (.poema-archive-
   ellipsis, its own line below the text) only on cards where the
   clamped .poema-archive-text box is actually cutting off content,
   instead of always showing a "Ler mais" link. */
(function () {
    document.querySelectorAll('.poema-archive-text').forEach(function (el) {
        if (el.scrollHeight > el.clientHeight + 1) {
            var ellipsis = el.parentElement.querySelector('.poema-archive-ellipsis');
            if (ellipsis) {
                ellipsis.hidden = false;
            }
        }
    });
})();

/* Agenda/Timeline posts hidden from every .gh-card listing (tag/
   author archives, the all-posts index) — see the .js-hidden-post-
   urls block in default.hbs for why this has to be done client-side. */
(function () {
    var container = document.querySelector('.js-hidden-post-urls');
    if (!container) {
        return;
    }

    var urls = Array.prototype.map.call(container.querySelectorAll('[data-url]'), function (el) {
        return el.dataset.url;
    });

    if (!urls.length) {
        return;
    }

    document.querySelectorAll('.gh-card').forEach(function (card) {
        var link = card.querySelector('.gh-card-link');
        if (link && urls.indexOf(link.getAttribute('href')) !== -1) {
            card.remove();
        }
    });
})();

/* Edições listing — client-side "load more" pagination: every
   edition already renders server-side (see custom-edicoes.hbs), this
   just reveals them in batches instead of all at once. */
(function () {
    var PAGE_SIZE = 12;

    // Editions whose date (parsed straight from the tag slug,
    // "edicao-YYYY-MM-DD") hasn't arrived yet stay hidden entirely —
    // not just off the first page, so "Mostrar mais" can never reveal
    // one early either.
    function removeFutureEditions(list) {
        var today = new Date();
        today.setHours(0, 0, 0, 0);

        Array.prototype.slice.call(list.querySelectorAll('.edicoes-list-item')).forEach(function (item) {
            var titleEl = item.querySelector('.js-edition-title');
            var slug = titleEl && titleEl.dataset.slug;
            var dated = slug && slug.match(/^edicao-(\d{4})-(\d{2})-(\d{2})$/);

            if (!dated) {
                return;
            }

            var editionDate = new Date(+dated[1], +dated[2] - 1, +dated[3]);
            if (editionDate > today) {
                item.remove();
            }
        });
    }

    document.querySelectorAll('.js-edicoes-list').forEach(function (list) {
        removeFutureEditions(list);

        var items = Array.prototype.slice.call(list.querySelectorAll('.edicoes-list-item'));
        var button = list.parentElement.querySelector('.js-edicoes-list-more');
        var shown = 0;

        if (!button) {
            return;
        }

        function showNextPage() {
            items.slice(shown, shown + PAGE_SIZE).forEach(function (item) {
                item.hidden = false;
            });
            shown += PAGE_SIZE;
            button.hidden = shown >= items.length;
        }

        items.forEach(function (item) {
            item.hidden = true;
        });

        showNextPage();
        button.addEventListener('click', showNextPage);
    });
})();

/* Dicionário da Novilíngua archive — fixed-length excerpt (same
   character count on every viewport), instead of the shared
   .gh-card-excerpt's line-based clamp, which shows more or less text
   depending on the column's width (see the display:block override
   in custom.css). */
(function () {
    var EXCERPT_LENGTH = 160;

    document.querySelectorAll('.dicionario-archive-feed .gh-card-excerpt').forEach(function (el) {
        var text = el.textContent.trim();

        if (text.length > EXCERPT_LENGTH) {
            el.textContent = text.slice(0, EXCERPT_LENGTH).trim() + '…';
        }
    });
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (
        !document.body.classList.contains('home-template') &&
        !document.body.classList.contains('post-template') &&
        !document.body.classList.contains('tag-template')
    ) {
        pagination();
    }
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();



document.addEventListener('DOMContentLoaded', function () {

    function fillFromPostContent(card, sourceSelector, targetSelector) {
        const source = card.querySelector('.js-home-post-content');
        const target = card.querySelector(targetSelector);

        if (!source || !target) {
            return;
        }

        const el = source.querySelector(sourceSelector);

        if (!el) {
            return;
        }

        target.innerHTML = el.innerHTML;

        // Normalize: if the copied content is a single wrapping <p>
        // (some posts author these as <div data-post-x><p>...</p></div>,
        // others as <p data-post-x>...</p> directly), unwrap it so every
        // card ends up with the same flat structure.
        if (target.children.length === 1 && target.firstElementChild.tagName === 'P') {
            target.innerHTML = target.firstElementChild.innerHTML;
        }
    }

    // Pulls whatever video already lives inside the post body (a YouTube
    // embed card, or Ghost's own self-hosted video card) and clones it
    // into the home card's video slot, so it doesn't need to be
    // configured twice. Ghost's native video card clones only the bare
    // <video> (not its play-button/seekbar UI, meant for the reader
    // controlling playback inside the article, not a hero background).
    // Capa has its own coordinating version of this (fillCapaMedia,
    // below) since it has to choose between video and image — skip it
    // here so the two don't fight over the same .js-home-video target.
    function fillVideoFromPostContent(card) {
        if (card.querySelector('.capa-media')) {
            return;
        }

        const source = card.querySelector('.js-home-post-content');
        const target = card.querySelector('.js-home-video');

        if (!source || !target) {
            return;
        }

        const iframe = source.querySelector('iframe[src*="youtube"], iframe[src*="youtu.be"]');

        if (iframe) {
            target.appendChild(iframe.cloneNode(true));
            target.classList.add('has-video');
            return;
        }

        const video = source.querySelector('.kg-video-card video');

        if (!video) {
            return;
        }

        const clone = video.cloneNode(true);
        clone.removeAttribute('controls');
        clone.setAttribute('muted', '');
        clone.muted = true;
        target.appendChild(clone);
        target.classList.add('has-video');
        clone.play().catch(function () {});
    }

    // Builds an ambient-background YouTube embed for a given video id:
    // silent autoplay loop, no player chrome, no tap needed to start
    // it. YouTube's embed only loops with `loop=1` when `playlist` is
    // also set to the same video id. Shared by the mobile snippet
    // override and the desktop first-body-card embed case below.
    function buildAmbientYouTubeIframe(id) {
        const params = 'autoplay=1&mute=1&loop=1&playlist=' + id
            + '&controls=0&playsinline=1&rel=0&modestbranding=1'
            + '&iv_load_policy=3&fs=0&disablekb=1&cc_load_policy=0';

        const iframe = document.createElement('iframe');
        iframe.src = 'https://www.youtube.com/embed/' + id + '?' + params;
        iframe.setAttribute('frameborder', '0');
        iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');

        return iframe;
    }

    function getYouTubeId(url) {
        const match = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
        return match ? match[1] : null;
    }

    // A "Capa Vídeo Mobile" snippet ([data-capa-mobile-link], a link to
    // a YouTube video) anywhere in the post body overrides the Feature
    // Image on mobile only — Feature Image is the fallback whenever
    // this snippet is absent. Independent of fillCapaMedia's own
    // first-body-card logic below (that one's desktop-only).
    function fillCapaMobileVideo(media, source) {
        const target = media.querySelector('.capa-mobile-video');
        const block = source.querySelector('[data-capa-mobile-link]');

        if (!target || !block) {
            return;
        }

        const link = block.querySelector('a[href]');
        const raw = (link ? link.getAttribute('href') : block.textContent || '').trim();
        const id = getYouTubeId(raw);

        if (!id) {
            return;
        }

        target.appendChild(buildAmbientYouTubeIframe(id));
        target.classList.add('has-video');
    }

    // Capa's desktop media is a single slot showing the post's first
    // relevant body card, whichever type it actually is — an image, a
    // native Ghost video, or a YouTube embed — never "any video
    // anywhere in the body" regardless of position. Feature Image
    // (mobile crop / no-JS fallback) is untouched either way.
    function fillCapaMedia(card) {
        const media = card.querySelector('.capa-media');
        const source = card.querySelector('.js-home-post-content');

        if (!media || !source) {
            return;
        }

        fillCapaMobileVideo(media, source);

        const first = source.querySelector('.kg-image-card, .kg-video-card, .kg-embed-card');

        if (!first) {
            return;
        }

        if (first.classList.contains('kg-image-card')) {
            const img = first.querySelector('img');
            const srcset = img && (img.getAttribute('srcset') || img.getAttribute('src'));

            if (!srcset) {
                return;
            }

            const sizes = img.getAttribute('sizes');

            // Has a Feature Image (mobile crop) — the body image is the
            // desktop-only <source> override.
            const desktopSource = media.querySelector('.js-capa-desktop-source');
            if (desktopSource) {
                desktopSource.setAttribute('srcset', srcset);
                if (sizes) {
                    desktopSource.setAttribute('sizes', sizes);
                }
                return;
            }

            // No Feature Image — swap the generic placeholder for the
            // body image, shown at every screen size.
            const fallback = media.querySelector('.js-capa-fallback-image');
            if (fallback) {
                fallback.setAttribute('srcset', srcset);
                if (sizes) {
                    fallback.setAttribute('sizes', sizes);
                }
                fallback.setAttribute('src', img.getAttribute('src') || '');
            }
            return;
        }

        const target = media.querySelector('.js-home-video');

        if (!target) {
            return;
        }

        if (first.classList.contains('kg-video-card')) {
            const video = first.querySelector('video');

            if (!video) {
                return;
            }

            const clone = video.cloneNode(true);
            clone.removeAttribute('controls');
            clone.setAttribute('muted', '');
            clone.muted = true;
            target.appendChild(clone);
            target.classList.add('has-video');
            clone.play().catch(function () {});
            return;
        }

        // .kg-embed-card — same ambient treatment as the mobile
        // snippet override, rebuilt from the embed's own video id
        // rather than cloning Ghost's iframe (which has none of it).
        const embedIframe = first.querySelector('iframe[src*="youtube"], iframe[src*="youtu.be"]');
        if (embedIframe) {
            const id = getYouTubeId(embedIframe.getAttribute('src') || '');
            if (id) {
                target.appendChild(buildAmbientYouTubeIframe(id));
                target.classList.add('has-video');
            }
        }
    }

    // Pulls whatever media the post's first content card is — a YouTube
    // embed, a Koenig gallery, or a single image — and clones it into the
    // home card's media slot. Tries video first (same embed fillVideoFromPostContent
    // looks for), then gallery, then a single image, so editors don't need
    // to configure the same media twice. Gallery/image are cloned as their
    // whole <figure> (not just the <img>) so a figcaption comes along too.
    // Same arrow used by .carousel-slider/.duo-slider (icons/arrow.hbs),
    // hardcoded here since this markup is built entirely client-side —
    // a Handlebars partial isn't available to it.
    const ARROW_SVG = '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 100 100"><polygon points="36.52 15.98 61.89 41.34 2.5 41.34 2.5 58.66 61.89 58.66 36.52 84.02 50 97.5 97.5 50 50 2.5 36.52 15.98"></polygon></svg>';

    // Every Koenig card type fillTimelineBody strips out of the visible
    // text, and initTimelineMediaLightbox looks for as the "first media"
    // to open in a lightbox/modal instead.
    const MEDIA_CARD_SELECTOR = '.kg-image-card, .kg-gallery-card, .kg-video-card, .kg-embed-card, .kg-file-card';

    // Builds a .media-slideshow element (one image at a time, prev/
    // next arrows) from a list of <img> elements — shared by the home/
    // archive card treatment below and the in-article one further
    // down. stopPropagation on the arrows: these cards are usually a
    // single big <a> (or, in the archive grids, open a lightbox on
    // image click) — an arrow click must only change slides, never
    // also navigate or open the lightbox underneath it.
    function buildSlideshowElement(images) {
        const slideshow = document.createElement('div');
        slideshow.className = 'media-slideshow';

        // .media-slideshow-viewport clips to one slide's width
        // (overflow:hidden); .media-slideshow-track holds every slide
        // side by side and slides via a transform, so moving between
        // images is an animated motion instead of an instant swap.
        const viewport = document.createElement('div');
        viewport.className = 'media-slideshow-viewport';

        const track = document.createElement('div');
        track.className = 'media-slideshow-track';

        images.forEach(function (img, index) {
            const slide = document.createElement('div');
            slide.className = 'media-slideshow-slide' + (index === 0 ? ' is-active' : '');
            slide.appendChild(img.cloneNode(true));
            track.appendChild(slide);
        });

        viewport.appendChild(track);
        slideshow.appendChild(viewport);

        const prev = document.createElement('button');
        prev.type = 'button';
        prev.className = 'slider-arrow media-slideshow-arrow media-slideshow-arrow--prev';
        prev.setAttribute('aria-label', 'Imagem anterior');
        prev.innerHTML = ARROW_SVG;

        const next = document.createElement('button');
        next.type = 'button';
        next.className = 'slider-arrow media-slideshow-arrow media-slideshow-arrow--next';
        next.setAttribute('aria-label', 'Imagem seguinte');
        next.innerHTML = ARROW_SVG;

        slideshow.appendChild(prev);
        slideshow.appendChild(next);

        const slides = track.querySelectorAll('.media-slideshow-slide');
        let current = 0;

        function show(index) {
            current = (index + slides.length) % slides.length;
            track.style.transform = 'translateX(' + (-current * 100) + '%)';
            slides.forEach(function (slide, i) {
                slide.classList.toggle('is-active', i === current);
            });
        }

        prev.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            show(current - 1);
        });

        next.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            show(current + 1);
        });

        return slideshow;
    }

    // Replaces Ghost's own multi-image gallery grid with one image at
    // a time plus prev/next arrows (see .media-slideshow in custom.css)
    // — same images, just shown one at a time instead of as a grid.
    // A single-image gallery is left alone (nothing to slide between).
    function buildGallerySlideshow(container) {
        const images = Array.prototype.slice.call(container.querySelectorAll('img'));

        if (images.length < 2) {
            return;
        }

        // Keep the gallery's own caption (a <figcaption> sibling of
        // .kg-gallery-container, inside the .kg-gallery-card that was
        // cloned into this container) — innerHTML='' below would
        // otherwise silently discard it along with everything else.
        const caption = container.querySelector('figcaption');
        const slideshow = buildSlideshowElement(images);
        container.innerHTML = '';
        container.appendChild(slideshow);

        if (caption) {
            container.appendChild(caption);
        }
    }

    function fillMediaFromPostContent(card) {
        const source = card.querySelector('.js-home-post-content');
        const target = card.querySelector('.js-home-media');

        if (!source || !target) {
            return;
        }

        const iframe = source.querySelector('iframe[src*="youtube"], iframe[src*="youtu.be"]');
        if (iframe) {
            target.appendChild(iframe.cloneNode(true));
            target.classList.add('is-video');
            return;
        }

        const gallery = source.querySelector('.kg-gallery-card');
        if (gallery) {
            target.appendChild(gallery.cloneNode(true));
            target.classList.add('is-gallery');

            // Keep Ghost's own default gallery grid (skip the slideshow)
            // when the source post itself uses the "Post Galeria Padrao"
            // template — same opt-out as that post's own page, see
            // custom-post-galeria-padrao.hbs / data-post-template above.
            if (source.dataset.postTemplate !== 'custom-post-galeria-padrao') {
                buildGallerySlideshow(target);
            }

            return;
        }

        // Native (self-hosted) Ghost video, as opposed to the YouTube
        // iframe case above — Do Nosso Lado posts are mostly this, and
        // without it the card was left completely empty (no image
        // fallback either: .media-archive-feature-image is display:none
        // by default, see media-archive-grid.hbs), collapsing to zero
        // height in the grid instead of showing anything at all. Clone
        // the whole kg-video-card, not just the <video> — the archive's
        // own click-to-lightbox handler (initArchiveMediaLightbox)
        // expects to find a kg-video-card-classed element here.
        const video = source.querySelector('.kg-video-card');
        if (video) {
            target.appendChild(video.cloneNode(true));
            target.classList.add('is-video');
            return;
        }

        const image = source.querySelector('.kg-image-card');
        if (image) {
            target.appendChild(image.cloneNode(true));
            target.classList.add('is-image');
        }
    }

    // Edition tag pages (tag.hbs, [data-edition-priority-sort]): posts
    // after the featured one don't just sort by date — Editorial and
    // Dicionário da Novilíngua come first, everything else keeps
    // publish-date order in the middle, and the lighter/media-only
    // sections sink to the bottom, in this exact order. A server-side
    // attempt (one {{#get}} per priority group instead of this) silently
    // dropped posts and let the featured post leak back in — Ghost's
    // theme-layer {{#get}} didn't handle a tag:-[...] exclusion list and
    // this many chained {{#get}} calls the way raw NQL against the Admin
    // API did for the identical filter — so this sorts client-side
    // instead, over the same single, already-reliable query every other
    // tag page uses.
    function sortEditionFeedByCategoryPriority() {
        const TOP = ['categoria-editorial', 'categoria-dicionario-da-novilingua'];
        const BOTTOM = [
            'categoria-o-tempo-contra-o-tempo',
            'categoria-cronica',
            'categoria-inquietacao',
            'categoria-do-nosso-lado',
            'categoria-o-cozinheiro-vermelho',
            'categoria-ombro-a-ombro',
            'categoria-um-poema',
            'categoria-um-livro',
            'categoria-um-filme',
            'categoria-um-programa-de-radio',
            'categoria-uma-cancao',
            'categoria-uma-serie',
            'categoria-aventuras',
            'categoria-bd',
            'categoria-so-trabalha'
        ];
        const MIDDLE_TIER = TOP.length;

        document.querySelectorAll('[data-edition-priority-sort]').forEach(function (feed) {
            const tierOf = function (card) {
                const slugs = Array.prototype.map.call(
                    card.querySelectorAll('.js-category-tag'),
                    function (el) { return el.dataset.slug; }
                );

                const topIndex = TOP.findIndex(function (slug) { return slugs.includes(slug); });
                if (topIndex !== -1) {
                    return topIndex;
                }

                const bottomIndex = BOTTOM.findIndex(function (slug) { return slugs.includes(slug); });
                if (bottomIndex !== -1) {
                    return MIDDLE_TIER + 1 + bottomIndex;
                }

                return MIDDLE_TIER;
            };

            Array.prototype.slice.call(feed.children)
                .map(function (card, index) {
                    return { card: card, tier: tierOf(card), index: index };
                })
                // Explicit index tie-break, not just reliance on Array.sort's
                // guaranteed stability — keeps same-tier posts in the server's
                // own published_at-desc order either way.
                .sort(function (a, b) { return a.tier - b.tier || a.index - b.index; })
                .forEach(function (entry) { feed.appendChild(entry.card); });
        });
    }

    // Timeline entries: "YYYY-MM-DD" (data-date-sort) is only the sort key
    // (see sortEntries below) and the source of the displayed year — the
    // "MÊS.DIA" text (.timeline-date-day) is rendered server-side straight
    // from the post's Custom Excerpt field instead (see timeline.hbs), so
    // it's never scraped into Ghost's own auto-excerpt the way text typed
    // directly in the post body would be.
    function fillTimelineDate(card) {
        const source = card.querySelector('.js-home-post-content');
        const yearTarget = card.querySelector('.timeline-date-year');

        if (!source || !yearTarget) {
            return;
        }

        const dateEl = source.querySelector('[data-post-date]');
        const sortValue = dateEl && dateEl.dataset.dateSort;

        if (!sortValue) {
            return;
        }

        yearTarget.textContent = sortValue.split('-')[0];
    }

    // Timeline entry body (.timeline-text): the post's full content, minus
    // the data-post-date marker card — same idea as fillAgendaBody below,
    // just with only one marker type to strip (Timeline has no pretitle/
    // subtitle/intro snippets).
    function fillTimelineBody(card) {
        const source = card.querySelector('.js-home-post-content');
        const target = card.querySelector('.js-timeline-text');

        if (!source || !target) {
            return;
        }

        const clone = source.cloneNode(true);

        clone.querySelectorAll('[data-post-date]').forEach(function (marker) {
            marker.remove();
        });

        // data-post-link has no text of its own to duplicate — unwrap
        // instead of remove so that if its HTML card is missing a closing
        // </a>, whatever got nested inside by mistake (the browser treats
        // unclosed tags as wrapping everything after them) survives.
        clone.querySelectorAll('[data-post-link]').forEach(function (marker) {
            marker.replaceWith(...marker.childNodes);
        });

        // Image/video/gallery/file cards don't belong inline in a
        // timeline entry's text — initTimelineMediaLightbox below
        // offers the first one as a lightbox/modal instead, when
        // there's no external link.
        clone.querySelectorAll(MEDIA_CARD_SELECTOR).forEach(function (media) {
            media.remove();
        });

        target.innerHTML = clone.innerHTML;
    }

    // When a timeline entry has no external link (data-post-link — see
    // fillLinkFromPostContent, which must run before this so .js-home-
    // link's hidden state is already decided), the first image, video,
    // gallery or file in its body becomes clickable instead: images/
    // galleries open in the same PhotoSwipe lightbox the archive grids
    // use, videos open in a simple modal, and a file just opens/
    // downloads directly (a lightbox doesn't make sense for a file).
    function initTimelineMediaLightbox(card) {
        if (!card.classList.contains('timeline-entry')) {
            return;
        }

        const link = card.querySelector('.js-home-link');

        // A real external link (fillLinkFromPostContent already ran
        // and revealed it with a real href) — make the whole entry
        // clickable to it too, not just the "Saber mais" link itself.
        // A click that started on the link is left alone (its own
        // native target="_blank" navigation already does the right
        // thing); anywhere else on the card opens it the same way by
        // hand, so there's never a double tab from both firing.
        if (link && !link.hidden) {
            card.classList.add('js-timeline-media-clickable');

            card.addEventListener('click', function (e) {
                if (e.target.closest('.js-home-link')) {
                    return;
                }

                window.open(link.getAttribute('href'), '_blank');
            });

            return;
        }

        const source = card.querySelector('.js-home-post-content');
        if (!source) {
            return;
        }

        const media = source.querySelector(MEDIA_CARD_SELECTOR);
        if (!media) {
            return;
        }

        card.classList.add('js-timeline-media-clickable');

        // Reuse the same "Saber mais" link/icon shown for a real
        // external link, as a visible affordance that this entry
        // opens something on click — it has no href to navigate to
        // here, so the entry's own click handler below runs instead
        // (preventDefault stops it from just reloading the page).
        if (link) {
            link.hidden = false;
        }

        card.addEventListener('click', function (e) {
            e.preventDefault();

            if (media.classList.contains('kg-image-card') || media.classList.contains('kg-gallery-card')) {
                const images = Array.prototype.slice.call(media.querySelectorAll('img'));
                if (!images.length) {
                    return;
                }

                // naturalWidth/Height are 0 here: these images come
                // from inside the hidden .js-home-post-content clone,
                // where loading="lazy" never triggers (a hidden
                // element never intersects the viewport) — Ghost
                // always writes real width/height attributes on every
                // Koenig image, so those are the reliable source,
                // regardless of whether the image itself has loaded.
                const items = images.map(function (img) {
                    return {
                        src: img.getAttribute('src'),
                        msrc: img.getAttribute('src'),
                        w: img.naturalWidth || parseInt(img.getAttribute('width'), 10) || 1200,
                        h: img.naturalHeight || parseInt(img.getAttribute('height'), 10) || 800
                    };
                });

                const pswpElement = document.querySelectorAll('.pswp')[0];
                const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, {
                    bgOpacity: 0.9,
                    closeOnScroll: true,
                    history: false,
                    shareEl: false
                });
                gallery.init();
                return;
            }

            if (media.classList.contains('kg-video-card')) {
                const video = media.querySelector('video');
                if (video) {
                    openMediaModal(video.cloneNode(true));
                }
                return;
            }

            if (media.classList.contains('kg-embed-card')) {
                const iframe = media.querySelector('iframe');
                if (iframe) {
                    openMediaModal(iframe.cloneNode(true));
                }
                return;
            }

            if (media.classList.contains('kg-file-card')) {
                const fileLink = media.querySelector('a[href]');
                if (fileLink) {
                    window.open(fileLink.getAttribute('href'), '_blank');
                }
            }
        });
    }

    // Minimal modal overlay for a video/embed element — PhotoSwipe
    // (used above for images/galleries) is image-only, no video
    // support. Closes on click anywhere, including the media itself.
    function openMediaModal(mediaEl) {
        const overlay = document.createElement('div');
        overlay.className = 'media-modal-overlay';

        const inner = document.createElement('div');
        inner.className = 'media-modal-inner';

        mediaEl.removeAttribute('width');
        mediaEl.removeAttribute('height');
        if (mediaEl.tagName === 'VIDEO') {
            mediaEl.setAttribute('controls', '');
            mediaEl.setAttribute('autoplay', '');
            mediaEl.muted = false;
        }

        inner.appendChild(mediaEl);
        overlay.appendChild(inner);
        document.body.appendChild(overlay);

        // Only the backdrop closes it — a click on the video itself
        // (e.g. its native play/pause controls) still bubbles up to
        // the overlay, so this checks the click actually started on
        // the backdrop rather than stopping propagation lower down.
        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) {
                overlay.remove();
            }
        });
    }

    // Timeline entries carry an optional external link as a plain
    // <a data-post-link href="..."> inside the post body (same HTML-card
    // trick as the other data-post-* fields). If present, reveals and
    // points the entry's own link element at it; otherwise the entry
    // just stays plain text with no link.
    function fillLinkFromPostContent(card) {
        const source = card.querySelector('.js-home-post-content');
        const target = card.querySelector('.js-home-link');

        if (!source || !target) {
            return;
        }

        const linkEl = source.querySelector('[data-post-link]');
        const href = linkEl && linkEl.getAttribute('href');

        if (!href) {
            return;
        }

        target.setAttribute('href', href);
        target.hidden = false;
    }

    // Agenda cards: same reveal mechanism as the categoria-* tags
    // (default.hbs) but for the agenda-* prefix instead — every agenda
    // post carries one #agenda-X tag (e.g. agenda-feira, agenda-festival)
    // among possibly others (hash-home-agenda, etc). Reveals only that
    // one, strips the "agenda-" prefix, and gives it a random color from
    // the curated palette (not sampled from the image — see PR discussion).
    var AGENDA_TAG_COLORS = ['#CA87C5', '#61CE70', '#879DCA', '#FFBD49'];

    function fillAgendaTag(card) {
        const candidates = card.querySelectorAll('.js-agenda-tag');

        if (!candidates.length) {
            return;
        }

        let match = null;

        candidates.forEach(function (el) {
            if (!match && (el.dataset.slug || '').startsWith('agenda-')) {
                match = el;
            }
        });

        candidates.forEach(function (el) {
            if (el !== match) {
                el.remove();
            }
        });

        if (!match) {
            return;
        }

        match.textContent = match.textContent.replace(/^agenda-/i, '').trim();
        match.classList.remove('js-agenda-tag');
        match.style.color = AGENDA_TAG_COLORS[Math.floor(Math.random() * AGENDA_TAG_COLORS.length)];
    }

    // Agenda's body is the post's full content, minus whatever
    // data-post-* marker cards it contains (pretitle/subtitle/date/
    // link) — those are already shown elsewhere in the card, so
    // leaving them in would duplicate that same text in the body.
    function fillAgendaBody(card) {
        const source = card.querySelector('.js-home-post-content');
        const target = card.querySelector('.js-agenda-body');

        if (!source || !target) {
            return;
        }

        const clone = source.cloneNode(true);

        // These carry their own text, already shown elsewhere in the
        // card (title area) — remove them whole, text included, or it
        // would duplicate into the body.
        clone.querySelectorAll('[data-post-pretitle], [data-post-subtitle], [data-post-intro], [data-post-date]').forEach(function (marker) {
            marker.remove();
        });

        // data-post-link is meant to stay empty (see agenda.hbs) — it
        // has no text of its own to duplicate. Unwrap instead of remove
        // so that if its HTML card is missing a closing </a>, whatever
        // got nested inside by mistake (the browser treats unclosed
        // tags as wrapping everything after them) survives instead of
        // being deleted along with the tag.
        clone.querySelectorAll('[data-post-link]').forEach(function (marker) {
            marker.replaceWith(...marker.childNodes);
        });

        // Image/video/gallery/file cards don't belong inline in this
        // body preview either — same reasoning as fillTimelineBody
        // above.
        clone.querySelectorAll(MEDIA_CARD_SELECTOR).forEach(function (media) {
            media.remove();
        });

        target.innerHTML = clone.innerHTML;
    }

    // Tempo Contra Tempo's card body (.js-tempo-contra-tempo-body): the
    // post's own body text, not the Entrada (used to be .js-home-intro
    // like Duo/Uno/Carousel — replaced, see tempo-contra-tempo.hbs).
    function fillTempoContraTempoBody(card) {
        const source = card.querySelector('.js-home-post-content');
        const target = card.querySelector('.js-tempo-contra-tempo-body');

        if (!source || !target) {
            return;
        }

        const clone = source.cloneNode(true);

        // Pretitle is shown separately as the episode number — remove
        // it whole (text included) so it doesn't duplicate into the
        // body. Subtitle/date aren't used by this section, stripped
        // defensively the same way in case either ever gets added.
        clone.querySelectorAll('[data-post-pretitle], [data-post-subtitle], [data-post-date]').forEach(function (marker) {
            marker.remove();
        });

        // Entrada/link have no other display slot here anymore, so
        // their text stays — unwrap rather than remove.
        clone.querySelectorAll('[data-post-intro], [data-post-link]').forEach(function (marker) {
            marker.replaceWith(...marker.childNodes);
        });

        // The video itself is already shown separately (.js-home-video)
        // — strip every image/video/gallery/file card so none of them
        // shows up a second time inline in the text.
        clone.querySelectorAll(MEDIA_CARD_SELECTOR).forEach(function (media) {
            media.remove();
        });

        target.innerHTML = clone.innerHTML;
    }

    // Do Nosso Lado / Cegadas card body (.js-do-nosso-lado-body): the
    // post's own body text, media stripped since it's already shown
    // separately in .js-home-media above it.
    function fillDoNossoLadoBody(card) {
        const source = card.querySelector('.js-home-post-content');
        const target = card.querySelector('.js-do-nosso-lado-body');

        if (!source || !target) {
            return;
        }

        const clone = source.cloneNode(true);

        clone.querySelectorAll('[data-post-pretitle], [data-post-subtitle], [data-post-date]').forEach(function (marker) {
            marker.remove();
        });

        clone.querySelectorAll('[data-post-intro], [data-post-link]').forEach(function (marker) {
            marker.replaceWith(...marker.childNodes);
        });

        clone.querySelectorAll(MEDIA_CARD_SELECTOR).forEach(function (media) {
            media.remove();
        });

        target.innerHTML = clone.innerHTML;
    }

    // Duo/Uno/Carousel's intro (.js-home-intro): shows the post's Entrada
    // (data-post-intro) snippet if present, otherwise falls back to
    // custom_excerpt — same fallback the full article page already has
    // (see default.hbs's pretitle/subtitle/intro script), just done here
    // since these cards are filled client-side instead of server-rendered.
    // The fallback text itself is rendered server-side (see duo/uno/
    // carousel.hbs) as a hidden <p data-intro-fallback>, so it only needs
    // revealing, not copying.
    function fillIntroOrFallback(card) {
        const source = card.querySelector('.js-home-post-content');
        const target = card.querySelector('.js-home-intro');

        if (!source || !target) {
            return;
        }

        const intro = source.querySelector('[data-post-intro]');

        if (intro) {
            target.innerHTML = intro.innerHTML;

            if (target.children.length === 1 && target.firstElementChild.tagName === 'P') {
                target.innerHTML = target.firstElementChild.innerHTML;
            }

            return;
        }

        const fallback = target.querySelector('[data-intro-fallback]');
        if (fallback) {
            fallback.hidden = false;
        }
    }

    // categoria-aventuras archive grid (js-archive-media-card, see tag.hbs) —
    // each card's images (already cloned into .js-home-media by
    // fillMediaFromPostContent, called just before this) open in the shared
    // PhotoSwipe lightbox instead of linking to the post. Scoped to this
    // card's own images only (not the general gallery lightbox() below,
    // whose sibling-in-post-body traversal would misread unrelated cards
    // sitting next to each other in this grid as being one gallery).
    function initArchiveMediaLightbox(card) {
        if (!card.classList.contains('js-archive-media-card')) {
            return;
        }

        const media = card.querySelector('.js-home-media');
        if (!media) {
            return;
        }

        const images = Array.prototype.slice.call(media.querySelectorAll('img'));
        if (!images.length) {
            return;
        }

        images.forEach(function (img) {
            img.addEventListener('click', function (e) {
                e.preventDefault();

                const items = images.map(function (im) {
                    return {
                        src: im.getAttribute('src'),
                        msrc: im.getAttribute('src'),
                        w: im.naturalWidth || parseInt(im.getAttribute('width'), 10) || 1200,
                        h: im.naturalHeight || parseInt(im.getAttribute('height'), 10) || 800,
                        el: im,
                    };
                });

                const pswpElement = document.querySelectorAll('.pswp')[0];

                const options = {
                    bgOpacity: 0.9,
                    closeOnScroll: true,
                    history: false,
                    index: images.indexOf(img),
                    shareEl: false,
                    getThumbBoundsFn: function (i) {
                        const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
                        const rect = items[i].el.getBoundingClientRect();

                        return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
                    }
                };

                const gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
                gallery.init();
            });
        });
    }

    document.querySelectorAll('.card').forEach(function (card) {
        fillFromPostContent(card, '[data-post-pretitle]', '.js-home-pretitle');
        fillFromPostContent(card, '[data-post-subtitle]', '.js-home-subtitle');
        fillIntroOrFallback(card);
        fillTimelineDate(card);
        fillTimelineBody(card);
        fillVideoFromPostContent(card);
        fillCapaMedia(card);
        fillMediaFromPostContent(card);
        fillLinkFromPostContent(card);
        initTimelineMediaLightbox(card);
        fillAgendaTag(card);
        fillAgendaBody(card);
        fillTempoContraTempoBody(card);
        fillDoNossoLadoBody(card);
        initArchiveMediaLightbox(card);
    });

    // Same pretitle/subtitle snippets as the home cards above, but for
    // the generic listing card (post-card.hbs) — "Ler mais", related
    // articles, tag/author archive listings. A separate loop rather
    // than folding .gh-card into the .card selector above: .gh-card
    // is Ghost's base-theme class, used in more places than the home
    // sections' own .card family, and none of the other home-card
    // features (video, timeline, agenda...) apply to it.
    document.querySelectorAll('.gh-card').forEach(function (card) {
        fillFromPostContent(card, '[data-post-pretitle]', '.js-home-pretitle');
        fillFromPostContent(card, '[data-post-subtitle]', '.js-home-subtitle');
    });

    // Multi-author lists ("Coletivo Habitação Hoje, Jornal Maio") can wrap
    // to a second line at narrow card widths — CSS alone can't stop a line
    // break landing mid-name (both the space inside "Habitação Hoje" and
    // the one after its comma are plain spaces to the browser). Swaps the
    // spaces WITHIN each name for non-breaking ones, leaving the space
    // after each comma breakable, so a wrap can only fall between authors,
    // never inside one.
    document.querySelectorAll('.home-card-author, .capa-author, .gh-card-author').forEach(function (el) {
        el.textContent = el.textContent
            .trim()
            .split(', ')
            .map(function (name) { return name.replace(/ /g, ' '); })
            .join(', ');
    });

    sortEditionFeedByCategoryPriority();

    // BD's image should browse the same category archive as the title
    // (categoria-bd, categoria-so-trabalha, ...), not just this
    // one post — the section is a pointer into an ongoing series. The
    // matching tag's href is already correct at render time (Handlebars
    // sets it per-tag in the loop, see bd.hbs), so this doesn't need to
    // wait for default.hbs's category-tag reveal script to run first.
    document.querySelectorAll('.section--bd').forEach(function (section) {
        const categoryLink = section.querySelector('[data-slug^="categoria-"]');
        const mediaLink = section.querySelector('.bd-link');

        if (categoryLink && mediaLink) {
            mediaLink.setAttribute('href', categoryLink.getAttribute('href'));
        }
    });

    // Every Koenig gallery inside an actual article body (post.hbs,
    // custom-post-*.hbs) — not the .js-home-media card previews
    // above, which .gh-content never wraps — gets the same one-at-a-
    // time slideshow treatment, keeping the .kg-gallery-card wrapper
    // itself (and its kg-width-wide/kg-width-full class) so the
    // gallery still occupies the right grid column, only swapping
    // its inner .kg-gallery-container for the slideshow. No click-to-
    // zoom, by request — Ghost's own gallery card has none to begin
    // with either. Skipped entirely for custom-post-galeria-padrao.hbs
    // (.gh-article--galeria-padrao), which keeps Ghost's own default
    // gallery grid on purpose.
    document.querySelectorAll('.gh-content .kg-gallery-card').forEach(function (gallery) {
        if (gallery.closest('.gh-article--galeria-padrao')) {
            return;
        }

        const images = Array.prototype.slice.call(gallery.querySelectorAll('img'));

        if (images.length < 2) {
            return;
        }

        const slideshow = buildSlideshowElement(images);
        const container = gallery.querySelector('.kg-gallery-container');

        if (container) {
            container.replaceWith(slideshow);
        } else {
            gallery.insertBefore(slideshow, gallery.firstChild);
        }
    });

});



document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.carousel-slider').forEach(function (slider) {

        const track = slider.querySelector('.carousel-track');
        const prev = slider.querySelector('.carousel-slider-arrow--prev');
        const next = slider.querySelector('.carousel-slider-arrow--next');

        if (!track || !prev || !next) {
            return;
        }

        function scrollByCard(direction) {
            const card = track.querySelector('.card');
            const gap = 24;
            const amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth;

            track.scrollBy({ left: direction * amount, behavior: 'smooth' });
        }

        // Arrows only make sense when the track actually has more content
        // than fits in view — how many cards that is changes with the
        // breakpoint (3 desktop, 2 tablet), so check real overflow instead
        // of a fixed post count, and re-check on resize.
        function updateArrowVisibility() {
            const canScroll = track.scrollWidth > track.clientWidth + 1;

            prev.style.display = canScroll ? '' : 'none';
            next.style.display = canScroll ? '' : 'none';
        }

        prev.addEventListener('click', function () {
            scrollByCard(-1);
        });

        next.addEventListener('click', function () {
            scrollByCard(1);
        });

        // Vertically centers the arrows on the first card's image
        // specifically (agenda's .agenda-media, or the generic
        // carousel's .card-vertical-image) rather than the whole card
        // including the title/text below it — same idea as duo's
        // alignArrowsToImage.
        function alignArrowsToImage() {
            const image = track.querySelector('.agenda-media, .card-vertical-image');

            if (!image) {
                return;
            }

            const imageRect = image.getBoundingClientRect();
            const sliderRect = slider.getBoundingClientRect();
            const top = (imageRect.top - sliderRect.top) + imageRect.height / 2;

            prev.style.top = `${top}px`;
            next.style.top = `${top}px`;
        }

        updateArrowVisibility();
        alignArrowsToImage();
        window.addEventListener('resize', function () {
            updateArrowVisibility();
            alignArrowsToImage();
        });

        // Sections below the fold use content-visibility: auto (see
        // custom.css, .section), so the track isn't laid out yet when
        // this runs on load — its width reads as 0 until the browser
        // actually renders it, which happens as it scrolls into view.
        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        updateArrowVisibility();
                        alignArrowsToImage();
                    }
                });
            });

            observer.observe(slider);
        }

    });

});



document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.duo-slider').forEach(function (slider) {

        const track = slider.querySelector('.duo-grid');
        const prev = slider.querySelector('.duo-slider-arrow--prev');
        const next = slider.querySelector('.duo-slider-arrow--next');

        if (!track || !prev || !next) {
            return;
        }

        function scrollByCard(direction) {
            const card = track.querySelector('.card-large');
            const gap = 16;
            const amount = card ? card.getBoundingClientRect().width + gap : track.clientWidth;

            track.scrollBy({ left: direction * amount, behavior: 'smooth' });
        }

        prev.addEventListener('click', function () {
            scrollByCard(-1);
        });

        next.addEventListener('click', function () {
            scrollByCard(1);
        });

        // Vertically centers the arrows on the card image specifically
        // (square, so its height depends on the responsive card width —
        // not a fixed value CSS alone can express), rather than the
        // whole slider including the text below the image.
        function alignArrowsToImage() {
            const image = track.querySelector('.card-vertical-image');

            if (!image) {
                return;
            }

            // getBoundingClientRect (not offsetTop) so this doesn't depend
            // on which ancestor happens to be the nearest positioned one.
            const imageRect = image.getBoundingClientRect();
            const sliderRect = slider.getBoundingClientRect();
            const top = (imageRect.top - sliderRect.top) + imageRect.height / 2;

            prev.style.top = `${top}px`;
            next.style.top = `${top}px`;
        }

        alignArrowsToImage();
        window.addEventListener('resize', alignArrowsToImage);

    });

});



document.addEventListener('DOMContentLoaded', function () {

    document.querySelectorAll('.timeline-slider').forEach(function (slider) {

        const track = slider.querySelector('.timeline-track');
        const prev = slider.querySelector('.timeline-slider-arrow--prev');
        const next = slider.querySelector('.timeline-slider-arrow--next');

        if (!track) {
            return;
        }

        // The Content API can only order posts by real fields (published_at,
        // title, ...) — the timeline's date is manual text buried in the post
        // body, invisible to that query. So posts render in published_at order
        // first (see timeline.hbs), then get reordered here using each post's
        // data-date-sort ("YYYY-MM-DD", so plain string comparison works).
        // Entries missing it (or a malformed one) sort last rather than
        // breaking the whole ordering.
        function sortEntries() {
            const entries = Array.from(track.querySelectorAll('.timeline-entry'));

            entries.sort(function (a, b) {
                const dateA = a.querySelector('[data-post-date]');
                const dateB = b.querySelector('[data-post-date]');
                const sortA = (dateA && dateA.dataset.dateSort) || '';
                const sortB = (dateB && dateB.dataset.dateSort) || '';

                if (!sortA) return 1;
                if (!sortB) return -1;

                return sortA < sortB ? -1 : sortA > sortB ? 1 : 0;
            });

            entries.forEach(function (entry) {
                track.appendChild(entry);
            });
        }

        sortEntries();

        // Start scrolled all the way to the right, so the most recent
        // entries (last in track order, per sortEntries above) are
        // what's visible on load instead of the oldest ones. Guarded
        // with a "done" flag rather than running once unconditionally:
        // the section can be below the fold with content-visibility:
        // auto (see the .carousel-slider handler's own comment on
        // this), so scrollWidth may still read as 0/unlaid-out at
        // DOMContentLoaded — this retries once the slider actually
        // intersects the viewport, but only ever sets it the first
        // time scrollWidth looks real, never overriding a scroll
        // position the reader has since moved away from.
        let hasSetInitialScroll = false;

        function scrollToEnd() {
            if (hasSetInitialScroll || track.scrollWidth <= track.clientWidth) {
                return;
            }

            track.scrollLeft = track.scrollWidth;
            hasSetInitialScroll = true;
        }

        scrollToEnd();

        if (!prev || !next) {
            return;
        }

        function scrollByEntry(direction) {
            const entry = track.querySelector('.timeline-entry');
            const amount = entry ? entry.getBoundingClientRect().width : track.clientWidth;

            track.scrollBy({ left: direction * amount, behavior: 'smooth' });
        }

        function updateArrowVisibility() {
            const canScroll = track.scrollWidth > track.clientWidth + 1;

            prev.style.display = canScroll ? '' : 'none';
            next.style.display = canScroll ? '' : 'none';
        }

        prev.addEventListener('click', function () {
            scrollByEntry(-1);
        });

        next.addEventListener('click', function () {
            scrollByEntry(1);
        });

        updateArrowVisibility();
        window.addEventListener('resize', updateArrowVisibility);

        if ('IntersectionObserver' in window) {
            const observer = new IntersectionObserver(function (entries) {
                entries.forEach(function (entry) {
                    if (entry.isIntersecting) {
                        scrollToEnd();
                        updateArrowVisibility();
                    }
                });
            });

            observer.observe(slider);
        }

    });
});

// Bookmark cards.
document.addEventListener('DOMContentLoaded', function () {

    // screen.css hides .kg-bookmark-icon/-author by default — the
    // target site's own favicon/name, redundant on a link back to
    // this same site — marks each card .is-external-bookmark when
    // its href points to a different hostname, so custom.css can
    // show the icon/name again only there.
    document.querySelectorAll('.kg-bookmark-card .kg-bookmark-container').forEach(function (link) {
        let linkHost;

        try {
            linkHost = new URL(link.href, window.location.href).hostname;
        } catch (e) {
            return;
        }

        if (linkHost && linkHost !== window.location.hostname) {
            link.closest('.kg-bookmark-card').classList.add('is-external-bookmark');
        }
    });

    // .kg-bookmark-thumbnail is a fixed 220px square (screen.css), but
    // .kg-bookmark-content's height depends on the title/description
    // length — center the shorter side against the taller one when
    // the thumbnail is taller, but align both to the top instead when
    // the content is taller (screen.css's align-items:center alone
    // can't conditionally pick a side, so this measures and sets it
    // inline per card). Skipped for .is-external-bookmark cards —
    // those fall through to Ghost's own default layout entirely, and
    // an inline alignItems here would override that.
    document.querySelectorAll('.kg-bookmark-card:not(.is-external-bookmark) .kg-bookmark-container').forEach(function (container) {
        const content = container.querySelector('.kg-bookmark-content');
        const thumbnail = container.querySelector('.kg-bookmark-thumbnail');

        if (!content || !thumbnail) {
            return;
        }

        function updateAlignment() {
            container.style.alignItems = content.offsetHeight > thumbnail.offsetHeight ? 'flex-start' : 'center';
        }

        updateAlignment();
        window.addEventListener('resize', updateAlignment);
    });

});

// .post-tags (desktop only, see custom.css) — follows scroll like
// position:sticky would, but computed by hand instead: sticky needs
// to be an in-flow grid item spanning every row of .gh-content to
// have room to travel, and that height was being counted when the
// grid sized the body's own early rows, pushing empty space in above
// the first real paragraph. position:absolute (custom.css) takes it
// out of that row-sizing calculation entirely; this recreates the
// "stays near the top of the viewport as you scroll" behaviour by
// hand, clamped so it never sits above the body's first paragraph of
// actual text (even if the post opens with an image/video before
// it) or below the content's own bottom.
document.addEventListener('DOMContentLoaded', function () {

    const STICKY_OFFSET = 32;

    document.querySelectorAll('.gh-content').forEach(function (content) {
        const tags = content.querySelector('.post-tags');

        if (!tags) {
            return;
        }

        function updatePosition() {
            if (window.innerWidth < 1200) {
                tags.style.top = '';
                return;
            }

            const contentRect = content.getBoundingClientRect();
            // First <p> OR <blockquote>, whichever comes first — not
            // just <p>, so a pull-quote placed before the body's first
            // real paragraph still counts as text to align to instead
            // of being skipped past like an image/video is. Excludes
            // a video card's own figcaption, which wraps its text in a
            // <p> too (unlike image cards, which use a <span>), and the
            // pretitle/subtitle/Entrada snippets — default.hbs moves
            // those into the header on DOMContentLoaded too, but its
            // script tag sits after this one's, so at the time this
            // first runs they're still (briefly) sitting at the very
            // top of the body; measuring against one of them anyway
            // would align to a paragraph that's about to disappear.
            const firstTextBlock = Array.from(content.querySelectorAll('p, blockquote')).find(function (el) {
                return !el.closest('figure')
                    && !el.closest('[data-post-pretitle], [data-post-subtitle], [data-post-intro]');
            });
            const minTop = firstTextBlock
                ? firstTextBlock.getBoundingClientRect().top - contentRect.top
                : 0;
            const maxTop = Math.max(minTop, content.offsetHeight - tags.offsetHeight);
            const scrolledPastTop = Math.max(0, STICKY_OFFSET - contentRect.top);
            const top = Math.min(Math.max(scrolledPastTop, minTop), maxTop);

            tags.style.top = `${top}px`;
        }

        updatePosition();
        window.addEventListener('scroll', updatePosition, { passive: true });
        window.addEventListener('resize', updatePosition);

        // Re-measure whenever the content's own size changes for any
        // reason — an image finishing loading, a web font swapping in
        // late (both happen after DOMContentLoaded, and fonts even
        // after window.load), or anything else that reflows the text.
        // More reliable than chasing each of those events individually.
        if ('ResizeObserver' in window) {
            new ResizeObserver(updatePosition).observe(content);
        }
    });

});

// Post Opiniao's author bio uses text-wrap:balance (screen.css) —
// that only decides how the text wraps INSIDE its box; the box
// itself still sizes to the text's unwrapped (single-line) width,
// leaving empty space beside the shorter balanced lines. Measuring
// the widest already-rendered (balanced) line and setting that as
// the bio's own width makes the box — and its wrapper/row ancestors,
// via ordinary flex shrink-to-fit — hug the balanced text instead.
document.addEventListener('DOMContentLoaded', function () {
    const AUTHOR_BIO_STACK_BREAKPOINT = 700;

    function widestLineWidth(el) {
        const range = document.createRange();
        range.selectNodeContents(el);
        const rects = range.getClientRects();
        let max = 0;
        for (let i = 0; i < rects.length; i++) {
            if (rects[i].width > max) {
                max = rects[i].width;
            }
        }
        return max;
    }

    // Runs `update` immediately, then again on the next couple of
    // animation frames, after document.fonts.ready, and once more
    // after a short delay — a single document.fonts.ready callback
    // alone wasn't a reliable enough signal that the real (not
    // fallback) font had actually finished swapping in and reflowing
    // before the measurement ran: reproduced live with a real, timing-
    // dependent difference between fresh navigations, and reported as
    // behaving differently across Firefox and Chrome. Each extra pass
    // is cheap and idempotent once the width is already correct, so
    // stacking several redundant correction points is safe.
    function scheduleWidthUpdate(update) {
        update();
        requestAnimationFrame(function () {
            update();
            requestAnimationFrame(update);
        });

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(update);
        }

        setTimeout(update, 300);
    }

    document.querySelectorAll('.gh-article--opiniao .gh-article-author-bio').forEach(function (bio) {
        function update() {
            bio.style.width = '';

            if (window.innerWidth < AUTHOR_BIO_STACK_BREAKPOINT) {
                return;
            }

            const width = widestLineWidth(bio);
            if (width > 0) {
                bio.style.width = (Math.ceil(width) + 1) + 'px';
            }
        }

        scheduleWidthUpdate(update);
        window.addEventListener('resize', update);
    });

    // Normal tag page title (.js-tag-title) — same text-wrap:balance
    // oversized-box issue as the bio above, fixed the same way.
    document.querySelectorAll('.js-tag-title').forEach(function (title) {
        function update() {
            title.style.width = '';

            const width = widestLineWidth(title);
            if (width > 0) {
                title.style.width = (Math.ceil(width) + 1) + 'px';
            }
        }

        scheduleWidthUpdate(update);
        window.addEventListener('resize', update);
    });
});

// Bookmark cards (Koenig's link-preview card) that point at another post
// on this site show that post's Pré-título/Sub-título snippets, same as
// the article page itself — Ghost's own bookmark scraper only ever pulls
// the target's <title>/meta description (.kg-bookmark-title/-description
// below), it has no way to see snippets that only exist inside the
// target's own body HTML. Also swaps in a fresh, untruncated meta
// description when the target page has one: Ghost's own scraper grabs
// .kg-bookmark-description once, at the moment the link is pasted into
// the editor, and (confirmed live, twice, on two unrelated posts) can
// cut it off mid-sentence with no "…" — since it's baked into this
// post's own body as static HTML from then on, editing the target's
// excerpt later never fixes an already-truncated bookmark. This can't
// un-truncate what Ghost's scraper already threw away, but replaces it
// with the target's current, complete meta description whenever one
// exists there now. Scoped to :not(.is-external-bookmark), same
// distinction custom.css already draws — that class is how Ghost itself
// marks a bookmark whose target is off-site, where fetching the URL for
// its markup wouldn't work (cross-origin) and wouldn't mean anything
// anyway (it's not one of this theme's own posts).
document.addEventListener('DOMContentLoaded', function () {
    const containers = document.querySelectorAll(
        '.kg-bookmark-card:not(.is-external-bookmark) .kg-bookmark-container[href]'
    );

    containers.forEach(function (container) {
        const href = container.getAttribute('href');
        const content = container.querySelector('.kg-bookmark-content');
        const titleEl = container.querySelector('.kg-bookmark-title');
        const descriptionEl = container.querySelector('.kg-bookmark-description');

        if (!href || !content || !titleEl) {
            return;
        }

        fetch(href)
            .then(function (res) { return res.text(); })
            .then(function (html) {
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const source = doc.querySelector('.gh-content');

                if (source) {
                    // Same single-<p>-wrapper unwrap as fillFromPostContent
                    // above — some posts author these as
                    // <div data-post-x><p>...</p></div>, others as
                    // <p data-post-x>...</p> directly.
                    function extract(selector) {
                        const el = source.querySelector(selector);
                        if (!el) {
                            return null;
                        }
                        if (el.children.length === 1 && el.firstElementChild.tagName === 'P') {
                            return el.firstElementChild.innerHTML;
                        }
                        return el.innerHTML;
                    }

                    const pretitleHtml = extract('[data-post-pretitle]');
                    const subtitleHtml = extract('[data-post-subtitle]');

                    if (pretitleHtml) {
                        const pretitle = document.createElement('div');
                        pretitle.className = 'kg-bookmark-pretitle';
                        pretitle.innerHTML = pretitleHtml;
                        content.insertBefore(pretitle, titleEl);
                    }

                    if (subtitleHtml) {
                        const subtitle = document.createElement('div');
                        subtitle.className = 'kg-bookmark-subtitle';
                        subtitle.innerHTML = subtitleHtml;
                        titleEl.insertAdjacentElement('afterend', subtitle);
                    }
                }

                if (descriptionEl) {
                    const meta = doc.querySelector('meta[name="description"]');
                    const freshDescription = meta && meta.getAttribute('content');

                    if (freshDescription) {
                        descriptionEl.textContent = freshDescription;
                    }
                }
            })
            .catch(function () {});
    });
});